export enum FormFieldTypes {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  CHECKBOX = 'checkbox',
  DATE_PICKER = 'date-picker',
  SELECT = 'select',
  SKELETON = 'skeleton',
  PHONE_INPUT = 'phone-input',
  PHONE_OTP = 'phone-otp',
}

/** Accept enum or string literal so you can use filedType="input" without importing FormFieldTypes. */
export type FormFieldType =
  | FormFieldTypes
  | 'input'
  | 'textarea'
  | 'checkbox'
  | 'date-picker'
  | 'select'
  | 'skeleton'
  | 'phone-input'
  | 'phone-otp';
